import Select from '@rio-cloud/rio-uikit/Select';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

interface ICalendarTitleProps {
    currentDate: Date;
    firstWeekDay: Date;
    lastWeekDay: Date;
    handleScheduleSidebar: () => void;
    scheduleViewType: string;
    setScheduleViewType: (scheduleViewType: string) => void;
}

const Title = ({ 
    currentDate,
    firstWeekDay, 
    lastWeekDay, 
    scheduleViewType,
    handleScheduleSidebar,
    setScheduleViewType,
}: ICalendarTitleProps) => {
    const navigate = useNavigate();
    const isResponsiveView = useMediaQuery('(max-width: 1024px)');
    
    const getFormatedFirstWeekDay = () => {
        if (firstWeekDay.getMonth() !== lastWeekDay.getMonth()) {
            return firstWeekDay.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' }).replace(/ de /g, ' ');
        } else {
            return firstWeekDay.toLocaleDateString('pt-BR', { day: '2-digit' });
        }
    }

    const renderFirstWeekFullYear = () => {
        return (
            <span className="text-normal">
                {firstWeekDay.getFullYear() !== lastWeekDay.getFullYear() ? firstWeekDay.getFullYear() : ''}
            </span>
        );
    }

    return (
        <div 
            className={`${isResponsiveView ? 'mobile-calendar-header' : 'height-80'} width-100pct ${isResponsiveView ? 'display-flex flex-direction-column' : 'display-grid gap-20 grid-cols-2-1fr-auto'}`}
            style={{ borderBottomWidth: 1 }}
        >
            <div className={`display-flex align-items-center ${isResponsiveView ? 'mobile-date-row padding-10' : ''}`}>
                <span className="rioglyph rioglyph-th-list padding-15 text-size-20 cursor-pointer" onClick={handleScheduleSidebar} />
                <div className="display-flex align-items-center" style={{ width: isResponsiveView ? '100%' : 'auto' }}>
                    {scheduleViewType === 'month' && 
                        <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
                            {currentDate.toLocaleDateString('pt-BR', { month: 'long' })} <span className="text-normal">{lastWeekDay.getFullYear()}</span>
                        </span>
                    }
                    {scheduleViewType === 'week' && 
                        <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
                            {getFormatedFirstWeekDay()}{renderFirstWeekFullYear()}
                            -{lastWeekDay
                                .toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' })
                                .replace(/ de /g, ' ')
                            } <span className="text-normal">{lastWeekDay.getFullYear()}</span>
                        </span>
                    }
                    {scheduleViewType === 'day' && 
                        <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
                            <span className="text-normal">{currentDate.toLocaleDateString('pt-BR', { weekday: 'long' })}, </span>
                            {currentDate.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' }).replace(/ de /g, ' ')}
                            <span className="text-normal"> {currentDate.getFullYear()}</span>
                        </span>
                    }
                    {!isResponsiveView && (
                        <div style={{ marginLeft: 16 }}>
                            <Select
                                placeholder='Tipo de cronograma'
                                options={[
                                    { id: 'month', label: 'Mês' },
                                    { id: 'week', label: 'Semana' },
                                    { id: 'day', label: 'Dia' }
                                ]}
                                onChange={item => setScheduleViewType(item!.id)}
                                btnClassName='btn btn-primary btn-outline'
                                value={[scheduleViewType]}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isResponsiveView && (
                <div className="display-flex align-items-center justify-content-space-between padding-10 gap-10">
                    <Select
                        placeholder='Tipo de cronograma'
                        options={[
                            { id: 'month', label: 'Mês' },
                            { id: 'week', label: 'Semana' },
                            { id: 'day', label: 'Dia' }
                        ]}
                        onChange={item => setScheduleViewType(item!.id)}
                        btnClassName='btn btn-primary btn-outline mobile-select'
                        value={[scheduleViewType]}
                    />
                    <button 
                        type="button" 
                        className="btn bg-highlight-darker mobile-create-btn" 
                        onClick={() => navigate('/dealership/appointments/appointment')}
                    >
                        <span className="text-capitalize">Criar</span>
                        <span className="rioglyph rioglyph-plus-sign" aria-hidden="true"/>
                    </button>
                </div>
            )}
            {!isResponsiveView && (
                <div className="display-flex align-items-center padding-20">
                    <button type="button" className="btn bg-highlight-darker padding-7" onClick={() => navigate('/dealership/appointments/appointment')}>
                        <span className="text-capitalize padding-right-5">Criar agendamento</span>
                        <span className="rioglyph rioglyph-plus-sign" aria-hidden="true"/>
                    </button>
                </div>
            )}
        </div>
    )
}

export default Title;